<template>
  <v-container fill-height fluid>
  </v-container>
</template>

<script>
export default {
  name: 'SilentCheckSso',
  methods: {
    postMessage() {
      window.parent.postMessage(window.location.href, window.location.origin);
    },
  },
  mounted() {
    this.postMessage();
  },
};
</script>
